import React from 'react';
import FolderIcon from '@material-ui/icons/Folder';
import DescriptionIcon from '@material-ui/icons/Description';

// Folders have no LastModified, so rank them above all files: they stay on top in the default (newest first) view.
const lastModifiedSortValue = row => row.is_folder ? Number.MAX_SAFE_INTEGER : (row.LastModifiedTs || 0);
// Ascending comparator; material-table swaps the arguments itself for descending order.
const sortByLastModified = (a, b) => lastModifiedSortValue(a) - lastModifiedSortValue(b);

const appConstants = {
    folderColumns: [
        {
            title: 'Name',
            field: 'Name',
            headerStyle: { fontWeight: 'bold' },
            cellStyle: {
                width: '30%',
                overfloWrap: 'anywhere'
            },
            render: rowData => <div style={{ display: 'flex' }}>
                <span style={{ paddingRight: '5px' }}>
                    {rowData.is_folder ? <FolderIcon fontSize="small" /> : <DescriptionIcon fontSize="small" />}
                </span>
                <span>{rowData.Name}</span>
            </div>
        },
        {
            title: 'Last Modified',
            field: 'LastModified',
            editable: 'never',
            searchable: false,
            headerStyle: { fontWeight: 'bold' },
            defaultSort: 'desc',
            customSort: sortByLastModified
        },
        {
            title: 'Storage Class',
            field: 'StorageClass',
            type: 'string',
            editable: 'never',
            searchable: false,
            headerStyle: { fontWeight: 'bold' }
        },
        {
            title: 'Size',
            field: 'ConvertedSize',
            type: 'string',
            editable: 'never',
            searchable: false,
            headerStyle: { fontWeight: 'bold' },
            customSort: (a, b) => parseInt(a.Size) - parseInt(b.Size)
        }
    ],
    restrictedAccessFolders: [{
        title: 'Name',
        field: 'Name',
        headerStyle: { fontWeight: 'bold' },
        render: rowData => <div style={{ display: 'flex', paddingRight: '5px' }}>
            <span style={{ paddingRight: '5px' }}><FolderIcon fontSize="small" /></span>
            <span>{rowData.Name}</span> </div>
    },

    {
        title: 'Created At',
        field: 'created_at',
        headerStyle: { fontWeight: 'bold' }

    }
    ],
    searchResultsFolders: [
        {
            title: 'Name',
            field: 'Name',
            cellStyle: {
                width: '30%',
                overfloWrap: 'anywhere'
            },
            headerStyle: { fontWeight: 'bold' },
            render: rowData => <div style={{ display: 'flex' }}><span style={{ paddingRight: '5px' }}>
                {rowData.is_folder ? <FolderIcon fontSize="small" /> : <DescriptionIcon fontSize="small" />}
            </span> <span>{rowData.Name}</span> </div>
        },
        {
            title: 'Last Modified',
            field: 'LastModified',
            editable: 'never',
            searchable: false,
            headerStyle: { fontWeight: 'bold' },
            defaultSort: 'desc',
            customSort: sortByLastModified
        },
        {
            title: 'Storage Class',
            field: 'StorageClass',
            type: 'string',
            editable: 'never',
            searchable: false,
            headerStyle: { fontWeight: 'bold' }
        },
        {
            title: 'Size',
            field: 'ConvertedSize',
            type: 'string',
            editable: 'never',
            searchable: false,
            headerStyle: { fontWeight: 'bold' },
            customSort: (a, b) => parseInt(a.Size) - parseInt(b.Size)
        }
    ]
};

export default appConstants;
